// src/pages/index.js
import React, { useEffect, useState } from 'react';
import Header from '../component/Header';
import Footer from '../component/Footer';
import Slider from "react-slick";
import axios from 'axios';
function Index() {
  const [brands, setBrands] = useState([]);
  const [vehcles, setVehicle] = useState([]);
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    axios
      .get(`${baseUrl}/brands`)
      .then((response) => {
        setBrands(response.data['brands']);
        console.log(response.data['brands'])
      })
      .catch((error) => {
        console.error('Failed to fetch brands:', error);
      });
  }, []);


  useEffect(() => {
    axios
      .post(`${baseUrl}/vehicles`)
      .then((response) => {
        setVehicle(response.data['VEHICLES']);
        console.log(response.data['VEHICLES'])
      })
      .catch((error) => {
        console.error('Failed to fetch brands:', error);
      });
  }, []);


  return (
    <>
     
      <Header />
      <div className="th-hero-wrapper hero-16" id="hero" style={{ backgroundImage: "url('/assets/img/hero/hero_bg_15_1.png')", backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center center" }}>
         <div className="hero-inner">
          <div className="container th-container4">
            <div className="row justify-content-center align-items-center">
              <div className="col-xl-6">
                <div className="hero-style16">
                  <span className="sub-title">
                    <div className="icon-masking me-2">
                      <span className="mask-icon" data-mask-src="assets/img/theme-img/title_shape_4.svg" />{" "}
                      <img src="assets/img/theme-img/title_shape_4.svg" alt="shape" />
                    </div>
                    Welcome to Ride 2 Luxury
                    <h1 className="hero-title">
                      Book Your
                      <br />
                      <span className="text-danger"> LUXURY VEHICLE</span>
                      with
                      <span className="text-theme"> Ride2luxury</span>
                    </h1>
                    <span className="text-dark">
                      Discover a world of convenience, safety, and customization,
                      paving the way for unforgettable adventures and seamless
                      mobility solutions.
                    </span>
                    <br />
                    <br />
                    <div className="btn-group">
                      <a
                        href="vehicle.html"
                        className="th-btn style-radius text-capitalize"
                      >
                        Find Vehicle
                      </a>
                      <div className="about-client-box style2 mb-sm-0 mb-3">
                        <div className="client-thumb-group">
                          <div className="thumb">
                            <img
                              src="assets/img/testimonial/client-img-1-1.png"
                              alt="avater"
                            />
                          </div>
                          <div className="thumb">
                            <img
                              src="assets/img/testimonial/client-img-1-2.png"
                              alt="avater"
                            />
                          </div>
                          <div className="thumb">
                            <img
                              src="assets/img/testimonial/client-img-1-3.png"
                              alt="avater"
                            />
                          </div>
                        </div>
                        <div className="cilent-box">
                          <div className="about_review">
                            <i className="fa-sharp fa-solid fa-star" />
                            <i className="fa-sharp fa-solid fa-star" />
                            <i className="fa-sharp fa-solid fa-star" />
                            <i className="fa-sharp fa-solid fa-star" />
                            <i className="fa-sharp fa-solid fa-star" />
                          </div>
                          <h4 className="cilent-box_counter">
                            <span className="counter-number">2960</span>+ Client
                            Reviews
                          </h4>
                        </div>
                      </div>
                    </div>
                    <div className="hero-counter_wrapp">
                      <div className="hero-counter">
                        <h2 className="counter-title mb-0">
                          <span className="counter-number">1000</span>+
                        </h2>
                        <span className="hero-counter_text">
                          Vehicle <br /> Added
                        </span>
                      </div>
                      <div className="hero-counter">
                        <h2 className="counter-title mb-0">
                          <span className="counter-number">14</span>
                        </h2>
                        <span className="hero-counter_text">
                          We are available in <br />
                          cities
                        </span>
                      </div>
                    </div>
                  </span>
                </div>
              </div>
              <div className="col-xl-6">
                <div className="th-hero-image">
                  <div className="th-hero-thumb">
                    <img src="assets/img/product/cars.png" alt="img" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="shape-mockup d-none d-xl-block"
          data-bottom="8%"
          data-left="4%"
        >
          <img src="assets/img/shape/shape_7.png" alt="shape" />
        </div>
        <div
          className="shape-mockup movingX d-none d-xl-block"
          data-top="54%"
          data-right="44%"
        >
          <img src="assets/img/shape/shape_8.png" alt="shape" />
        </div>
        <div
          className="shape-mockup spin d-none d-xl-block"
          data-bottom="14%"
          data-right="6%"
        >
          <img src="assets/img/shape/shape_9.png" alt="shape" />
        </div>
      </div>
      <div className="brand-sec8 bg-title overflow-hidden">
        <div className="container th-container4">
          <div className="slider-area ">
            <div className="swiper th-slider" id="brandSlider3" >
              <Slider dots={false} arrows={false} infinite={true} autoplay={true} autoplaySpeed={2000} speed={2000} slidesToShow={5} slidesToScroll={1} responsive={[{ breakpoint: 1200, settings: { slidesToShow: 4 } }, { breakpoint: 992, settings: { slidesToShow: 3 } }, { breakpoint: 768, settings: { slidesToShow: 2 } }, { breakpoint: 480, settings: { slidesToShow: 1 } }]}>
              {brands.map((brand, index) => (
                <div className="swiper-slide item-align-center" key={index}>
                <a href="" className="brand-box style4 d-flex align-items-center justify-content-center">
                  <img className='m-1' src={brand.brand_image || "assets/img/brand/brand_8_1.svg"} alt={brand.name || "Brand Logo"}  width={60}/> 
                  <span style={{ fontSize: '30px',color: '#000',  display: 'inline-block', fontWeight: 'bold',}}> {brand.brand_name || 'Waiting'}</span>
                </a>
              </div>
              ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
      <section className="service-sec15 space" id="service-sec" style={{ backgroundImage: "url('/assets/img/hero/hero_bg_7_1.png')", backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center center" }} >
        <div className="container th-container4">
          <div className="row justify-content-center">
            <div className="col-lg-6 col-md-7 col-sm-10 px-xl-4">
              <div className="title-area text-center">
                <span className="sub-title">
                  <div className="icon-masking me-2" />
                  <img src="assets/img/product/vehicles.png" width="300px" />
                </span>
                <h2 className="sec-title">Our Vehicle fleets</h2>
              </div>
            </div>
          </div>
          <div className="slider-area">
            <Slider dots={false} spaceBetween={20} arrows={false} infinite={true} autoplay={true} autoplaySpeed={2500} speed={2500} slidesToShow={3} slidesToScroll={1} responsive={[{ breakpoint: 1200, settings: { slidesToShow: 2 } }, { breakpoint: 768, settings: { slidesToShow: 1 } }, { breakpoint: 480, settings: { slidesToShow: 1 } }]}>
             
            {vehcles && vehcles.length > 0 ? (
                vehcles.map((vehicle, index) => (
                  <div className="swiper-slide" key={index}>
                    <div className="blog-box2 style2 m-2">
                      <div className="mb-3 d-flex align-items-center justify-content-center" >
                        <img className="" width={300} src={vehicle.vehicle_image || "assets/img/loading/carLoading.gif"} alt="Image" />
                      </div>
                      <div className="row">
                        <div className="col-xl-9 col-md-9 col-sm-9 col-9">
                          <h3 className="box-title mb-0">
                            {vehicle.brand || 'Waiting...'}
                          </h3>
                          <span><b>{vehicle.model || 'Waiting...'}</b></span>
                        </div>
                        <div className="col-xl-3 col-md-3 col-sm-3 col-3">
                          <h6>
                            {vehicle.rating || '0'}{" "}
                            <i className="fa-sharp fa-solid fa-star text-warning" width="20px" />
                          </h6>
                        </div>
                      </div>
                      <div className="cilent-box">
                        <div className="about_review">
                          <i className="fa-sharp fa-solid fa-user text-primary" />
                          <span className="text-dark">{vehicle.no_of_seat || '0'}</span> &nbsp;&nbsp;&nbsp;
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={20} height={20} fill="#0d6efd">
                            <path d="M4 22h16c1.1 0 2-.9 2-2V9.83c0-.53-.21-1.04-.59-1.41L14.59 2.59C14.21 2.21 13.7 2 13.17 2H8c-1.1 0-2 .9-2 2v4H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2zM8 4h5.17l6 6H8V4zm0 14H6v-2h2v2zm10 0H10v-2h8v2z" />
                          </svg>
                          <span className="text-dark">{vehicle.no_of_door || '0'}</span>&nbsp;&nbsp;&nbsp;
                          <i className="fa-sharp fa fa-shopping-bag text-primary" />
                          <span className="text-dark">{vehicle.no_of_door || '0'}</span>&nbsp;&nbsp;&nbsp;
                          <i className="fa-sharp fa-solid fa fa-car text-primary" />
                          <span className="text-dark"> {vehicle.body || '0'}</span>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-xl-6 col-md-6 col-sm-6 col-6">
                          <h5>
                            Rs {vehicle.price || '0'} <span>/Days</span>
                          </h5>
                        </div>
                        <div className="col-xl-6 col-md-6 col-sm-6 col-6 text-end">
                          <a href={"/vehcile-details?id="+vehicle.id} className="th-btn style-radius text-capitalize">
                            View
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                  <div className="blog-box2 style2 m-2">
                    <div className="mb-3">
                      <img className="card" src="assets/img/loading/carLoading.gif" alt="Loading Icon" />
                    </div>
                    <div className="row">
                      <div className="col-xl-9 col-md-9 col-sm-9 col-9">
                        <h3 className="box-title mb-0">JAGUAR</h3>
                        <span><b>Xe 2026 Top Model</b></span>
                      </div>
                      <div className="col-xl-3 col-md-3 col-sm-3 col-3">
                        <h6>
                          4.8{" "}
                          <i className="fa-sharp fa-solid fa-star text-warning" width="20px" />
                        </h6>
                      </div>
                    </div>
                    <div className="cilent-box">
                      <div className="about_review">
                        <i className="fa-sharp fa-solid fa-user text-primary" />
                        <span className="text-dark"> 5</span>&nbsp;&nbsp;&nbsp;
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={20} height={20} fill="#0d6efd">
                          <path d="M4 22h16c1.1 0 2-.9 2-2V9.83c0-.53-.21-1.04-.59-1.41L14.59 2.59C14.21 2.21 13.7 2 13.17 2H8c-1.1 0-2 .9-2 2v4H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2zM8 4h5.17l6 6H8V4zm0 14H6v-2h2v2zm10 0H10v-2h8v2z" />
                        </svg>
                        <span className="text-dark">2</span>&nbsp;&nbsp;&nbsp;
                        <i className="fa-sharp fa fa-shopping-bag text-primary" />
                        <span className="text-dark">5</span>&nbsp;&nbsp;&nbsp;
                        <i className="fa-sharp fa-solid fa fa-car text-primary" />
                        <span className="text-dark">SUV</span>
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-xl-6 col-md-6 col-sm-6 col-6">
                        <h5>
                          Rs 12000 <span>/Days</span>
                        </h5>
                      </div>
                      <div className="col-xl-6 col-md-6 col-sm-6 col-6 text-end">
                        <a href="about.html" className="th-btn style-radius text-capitalize">
                          View
                        </a>
                      </div>
                    </div>
                  </div>
              )}
            </Slider>
          </div>
        </div>
      </section>
      <div className="space-bottom" id="about-sec">
        <div className="container th-container4">
          <div className="row">
            <div className="col-xl-6 mb-30 mb-xl-0">
              <div className="img-box17 pe-xl-5">
                <div className="img1">
                  <img src="assets/img/gallery/about.png" alt="About" />
                </div>
              </div>
            </div>
            <div className="col-xl-6">
              <div className="title-area mb-35">
                <span className="sub-title text-capitalize fs-20">
                  <div className="icon-masking me-2">
                    <img src="assets/img/theme-img/title_shape_4.svg" alt="shape" />
                  </div>
                  About Ride 2 Luxury
                </span>
                <h2 className="sec-title">
                  Elevating Your Experience with Premium &amp; Affordable Luxury Car
                  Rentals in India
                </h2>
              </div>
              <p className="mt-n2 mb-25">
                Welcome to Ride2Luxury, your premier destination for luxury vehicle
                rentals at unbeatable prices. Whether you're looking for an elite
                experience for a special occasion, a high-end car for business
                travel, or simply want to enjoy the thrill of a luxury ride, we have
                you covered. At Ride2Luxury, we offer a fleet of world-class luxury
                vehicles, including top brands like{" "}
                <b> Mercedes-Benz, BMW, Audi, Rolls-Royce, and more.</b> Our
                services are designed to bring you{" "}
                <b>comfort, sophistication, and affordability</b>—so you can ride in
                style without breaking the bank.
              </p>
              <div className="about-feature-wrap style5">
                <div>
                  <div className="about-feature style5">
                    <div className="about-feature_icon">
                      <img src="assets/img/icon/about_feature_2_1.svg" alt="Icon" />
                    </div>
                    <div className="media-body">
                      <h3 className="about-feature_title">
                        Choose from a range of luxury and exotic cars.
                      </h3>
                    </div>
                  </div>
                  <div className="about-feature style5">
                    <div className="about-feature_icon">
                      <img src="assets/img/icon/about_feature_2_2.svg" alt="Icon" />
                    </div>
                    <div className="media-body">
                      <h3 className="about-feature_title">
                        Professional drivers for a seamless experience.
                      </h3>
                    </div>
                  </div>
                  <div className="btn-group style3">
                    <a
                      href="about.html"
                      className="th-btn style-radius text-capitalize"
                    >
                      Get Started
                    </a>
                    <div className="call-btn">
                      <i className="fas fa-phone" />
                      <div className="media-body">
                        <span className="btn-text">Call Now!</span>{" "}
                        <a href="tel:+25632542598" className="btn-title">
                          (+256) 3254 2598
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="shape-mockup" data-bottom="0%" data-right="0%">
        <img src="assets/img/shape/about_shape.png" alt="shape" />
      </div>
      <section
        className="process-area4 th-radius3 space"
        id="process-sec"
        style={{ backgroundImage: "url('/assets/img/bg/process_bg_3.jpg')", backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center center" }}

      >
        <div className="container th-container4">
          <div className="title-area text-center">
            <span className="sub-title text-white">
              <div className="icon-masking me-2">
                <img src="assets/img/theme-img/title_shape_4.1.svg" alt="shape" />
              </div>
              Booking PROCES
            </span>
            <h2 className="sec-title text-white">
              Complete In Just 4 Steps Process
            </h2>
          </div>
          <div className="process-card-area">
            <div className="row gy-40">
              <div className="col-md-6 col-lg-3 process-card2-wrap">
                <div className="process-card2">
                  <div className="process-card2_number">01</div>
                  <div className="process-card2_icon">
                    <img
                      src="assets/img/gallery/chooseVehicle.png"
                      width="80%"
                      alt="icon"
                    />
                  </div>
                  <h2 className="box-title">Choose a vehicle</h2>
                  <p className="process-card2_text">
                    Unlock unparalleled adventures and memorable journeys with our
                    vast fleet of vehicles tailored to suit every need, taste, and
                    destination.
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-3 process-card2-wrap">
                <div className="process-card2">
                  <div className="process-card2_number">02</div>
                  <div className="process-card2_icon">
                    <img
                      src="assets/img/gallery/location.webp"
                      width="80%"
                      alt="icon"
                    />
                  </div>
                  <h2 className="box-title">Pick location &amp; date</h2>
                  <p className="process-card2_text">
                    Pick your ideal location and date, and let us take you on a
                    journey filled with convenience, flexibility, and unforgettable
                    experiences.
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-3 process-card2-wrap">
                <div className="process-card2">
                  <div className="process-card2_number">03</div>
                  <div className="process-card2_icon">
                    <img
                      src="assets/img/gallery/booking.webp"
                      width="80%"
                      alt="icon"
                    />
                  </div>
                  <h2 className="box-title">Make a booking</h2>
                  <p className="process-card2_text">
                    Secure your reservation with ease, unlocking a world of
                    possibilities and embarking on your next adventure with
                    confidence.
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-3 process-card2-wrap">
                <div className="process-card2">
                  <div className="process-card2_number">04</div>
                  <div className="process-card2_icon">
                    <img src="assets/img/gallery/relax.png" alt="icon" />
                  </div>
                  <h2 className="box-title">Sit back &amp; relax</h2>
                  <p className="process-card2_text">
                    Hassle-free convenience as we take care of every detail,
                    allowing you to unwind and embrace a journey filled comfort.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="overflow-hidden space">
        <div className="container th-container4">
          <div className="row gy-4">
            <div className="col-xl-6">
              <div className="title-area">
                <span className="sub-title">
                  <div className="icon-masking me-2">
                    <img src="assets/img/theme-img/title_shape_4.svg" alt="shape" />
                  </div>
                  kay of feature
                </span>
                <h2 className="sec-title">All access in your hand</h2>
                <p>
                  Experience the power of our feature-rich mobile app, packed with
                  advanced functionalities you never imagined! Enjoy seamless
                  booking, real-time tracking, instant chat &amp; call support, SOS
                  assistance, and immersive vehicle previews—all at your fingertips.
                </p>
              </div>
              <div className="feature-wrapp">
                <div className="feature-item">
                  <div className="feature-item_icon">
                    <img src="assets/img/icon/feature_1_1.svg" alt="Icon" />
                  </div>
                  <div className="media-body">
                    <h3 className="box-title">
                      View detailed images and videos of your chosen luxury car
                      before booking.
                    </h3>
                  </div>
                </div>
                <div className="feature-item">
                  <div className="feature-item_icon">
                    <img src="assets/img/icon/feature_1_2.svg" alt="Icon" />
                  </div>
                  <div className="media-body">
                    <h3 className="box-title">
                      Track your luxury ride live and stay updated with accurate
                      arrival times.
                    </h3>
                  </div>
                </div>
                <div className="feature-item">
                  <div className="feature-item_icon">
                    <img src="assets/img/icon/feature_1_3.svg" alt="Icon" />
                  </div>
                  <div className="media-body">
                    <h3 className="box-title">
                      Live chat and call support – with users and drivers.
                    </h3>
                  </div>
                </div>
                <div className="feature-item">
                  <div className="feature-item_icon">
                    <img src="assets/img/icon/feature_1_4.svg" alt="Icon" />
                  </div>
                  <div className="media-body">
                    <h3 className="box-title">
                      SOS Assistance – Instant emergency alerts for your safety.
                    </h3>
                  </div>
                </div>
              </div>
              <div className="feature-wrap style2">
                <div className="btn-wrap">
                  <a href="about.html" className="th-btn style-border style-radius">
                    Explore Features
                  </a>
                </div>
                <div className="about-client-box style2 mb-sm-0 mb-3">
                  <div className="client-thumb-group">
                    <div className="thumb">
                      <img
                        src="assets/img/testimonial/client-img-1-1.png"
                        alt="avater"
                      />
                    </div>
                    <div className="thumb">
                      <img
                        src="assets/img/testimonial/client-img-1-2.png"
                        alt="avater"
                      />
                    </div>
                    <div className="thumb">
                      <img
                        src="assets/img/testimonial/client-img-1-3.png"
                        alt="avater"
                      />
                    </div>
                  </div>
                  <div className="cilent-box">
                    <div className="about_review">
                      <i className="fa-sharp fa-solid fa-star" />
                      <i className="fa-sharp fa-solid fa-star" />
                      <i className="fa-sharp fa-solid fa-star" />
                      <i className="fa-sharp fa-solid fa-star" />
                      <i className="fa-sharp fa-solid fa-star" />
                    </div>
                    <h4 className="cilent-box_counter">
                      <span className="counter-number">2960</span>+ Client Reviews
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6">
              <div className="feature-image7">
                <img src="assets/img/normal/feature-11-1.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="overflow-hidden space"
        id="contact-sec"
        style={{ backgroundImage: "url('/assets/img/bg/contact_bg_7.jpg')", backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center center" }}
      >
        <div className="container th-container4">
          <div className="title-area text-center">
            <span className="sub-title">
              <div className="icon-masking me-2">
                <img src="assets/img/theme-img/title_shape_4.svg" alt="shape" />
              </div>
              contact us
            </span>
            <h2 className="sec-title text-white">Join our unforgettable jurney</h2>
          </div>
          <div className="row gy-4 justify-content-center">
            <div className="col-xl-9">
              <form
                action="https://html.themeholy.com/webteck/demo/mail.php"
                method="POST"
                className="contact-form2 ajax-contact"
              >
                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        id="name"
                        placeholder="Your name"
                      />{" "}
                      <i className="fa-solid fa-user" />
                    </div>
                    <div className="form-group">
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        id="email"
                        placeholder="Your Email"
                      />{" "}
                      <i className="fa-sharp fa-solid fa-envelope" />
                    </div>
                    <div className="col-12 form-group">
                      <input type="checkbox" id="html" />{" "}
                      <label htmlFor="html">
                        I Agree With Terms of Use and Privacy Policy
                      </label>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <textarea
                        name="message"
                        id="message"
                        cols={30}
                        rows={3}
                        className="form-control"
                        placeholder="Write Your Message"
                        defaultValue={""}
                      />{" "}
                      <i className="fa-solid fa-pen" />
                    </div>
                    <div className="form-btn">
                      <button className="th-btn style-radius text-capitalize w-100">
                        Send Message
                      </button>
                    </div>
                  </div>
                  <p className="form-messages mb-0 mt-3" />
                </div>
              </form>
            </div>
            <div className="col-xl-3">
              <div className="contact-item-wrap">
                <div className="contact-item">
                  <div className="contact-item_icon">
                    <i className="fa-solid fa-phone" />
                  </div>
                  <div className="media-body">
                    <p className="contact-item_label">Call Now!</p>
                    <a href="tel:+2563254 2598" className="contact-item_link">
                      (+91) 8318754257
                    </a>
                  </div>
                </div>
                <div className="contact-item">
                  <div className="contact-item_icon">
                    <i className="fas fa-location-dot" />
                  </div>
                  <div className="media-body">
                    <p className="contact-item_label">Locations</p>
                    <span className="contact-item_text">
                      Gorakhpur (Uttar Pradesh) India
                    </span>
                  </div>
                </div>
                <div className="contact-item">
                  <div className="contact-item_icon">
                    <i className="fa-solid fa-envelope" />
                  </div>
                  <div className="media-body">
                    <p className="contact-item_label">Email:</p>
                    <a href="mailto:info@webteck.com" className="contact-item_link">
                      contact@ride2luxury.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="faq-area position-relative space" id="faq-sec">
        <div className="container th-container4">
          <div className="row">
            <div className="col-xl-6">
              <div className="faq-img7 mb-xl-0 mt-xl-0 mt-n4 pe-xl-5 me-xl-1">
                <div className="img1">
                  <img src="assets/img/gallery/askQuestion.avif" alt="About" />
                  <div className="img2 jump">
                    <img
                      src="assets/img/gallery/ques1.jpg"
                      width="150px"
                      alt="About"
                    />
                  </div>
                  <div className="img3 movingX">
                    <img
                      src="assets/img/gallery/ques2.jpg"
                      width="150px"
                      alt="About"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6">
              <div className="title-area pe-xl-5 me-xl-4 text-center text-xl-start">
                <span className="sub-title style1">
                  <div className="icon-masking me-2">
                    <img src="assets/img/theme-img/title_shape_4.svg" alt="shape" />
                  </div>
                  Frequently asked Question
                </span>
                <h2 className="sec-title">
                  Everything You Need to Know About Ride2Luxury
                </h2>
              </div>
              <div className="accordion" id="faqAccordion">
                <div className="accordion-card style7">
                  <div className="accordion-header" id="collapse-item-1">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse-1"
                      aria-expanded="true"
                      aria-controls="collapse-1"
                    >
                      Do I need a marketing degree to use Webteck?
                    </button>
                  </div>
                  <div
                    id="collapse-1"
                    className="accordion-collapse collapse show"
                    aria-labelledby="collapse-item-1"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      <p className="faq-text">
                        No marketing degree is required! Webteck's intuitive
                        interface and built-in features empower you to create
                        effective marketing campaigns even without prior
                        experience..
                      </p>
                    </div>
                  </div>
                </div>
                <div className="accordion-card style7">
                  <div className="accordion-header" id="collapse-item-2">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse-2"
                      aria-expanded="false"
                      aria-controls="collapse-2"
                    >
                      What kind of content can I create with Webteck?
                    </button>
                  </div>
                  <div
                    id="collapse-2"
                    className="accordion-collapse collapse"
                    aria-labelledby="collapse-item-2"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      <p className="faq-text">
                        As of my last knowledge update in January 2022, Digix refers
                        to DigixGlobal, a company that tokenizes physical assets,
                        primarily gold, on the Ethereum blockchain.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="accordion-card style7">
                  <div className="accordion-header" id="collapse-item-3">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse-3"
                      aria-expanded="false"
                      aria-controls="collapse-3"
                    >
                      Does Webteck integrate with other tools I use?
                    </button>
                  </div>
                  <div
                    id="collapse-3"
                    className="accordion-collapse collapse"
                    aria-labelledby="collapse-item-3"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      <p className="faq-text">
                        Implementing automation for routine and repetitive tasks can
                        significantly reduce manual effort and the risk of errors.
                        This can be achieved through the use of software tools,
                        scripts, or robotic process automation (RPA) systems.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="accordion-card style7">
                  <div className="accordion-header" id="collapse-item-4">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse-4"
                      aria-expanded="false"
                      aria-controls="collapse-4"
                    >
                      What kind of analytics does Webteck offer?
                    </button>
                  </div>
                  <div
                    id="collapse-4"
                    className="accordion-collapse collapse"
                    aria-labelledby="collapse-item-4"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      <p className="faq-text">
                        Webteck offers a variety of benefits, including increased
                        productivity, streamlined workflows, enhanced collaboration,
                        improved data-driven decision making, and more.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section
        className="testi-area13 space"
        style={{ backgroundImage: "url('/assets/img/bg/testi_bg_11.jpg')", backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center center" }}
      >
        <div className="container">
          <div className="title-area text-center">
            <span className="sub-title">
              <div className="icon-masking me-2">
                <img src="assets/img/theme-img/title_shape_4.svg" alt="shape" />
              </div>
              Client Feedback
            </span>
            <h2 className="sec-title">Inspiring Testimonials</h2>
          </div>
          <div className="slider-area testi-grid2-area style3">
            <div className="testi-indicator">
              <div className="swiper th-slider testi-grid2-thumb" data-slider-options='{"effect":"slide","slidesPerView":"5","spaceBetween":13,"loop":true,"breakpoints":{"0":{"slidesPerView":4},"576":{"slidesPerView":"5"}}}' data-slider-tab="#testiSlide1">
                <div className="swiper-wrapper">
                  <div className="swiper-slide">
                    <div className="box-img">
                      <img src="assets/img/testimonial/testi_1_1.png" alt="Image" />
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="box-img">
                      <img src="assets/img/testimonial/testi_1_2.png" alt="Image" />
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="box-img">
                      <img src="assets/img/testimonial/testi_1_3.png" alt="Image" />
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="box-img">
                      <img src="assets/img/testimonial/testi_1_4.png" alt="Image" />
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="box-img">
                      <img src="assets/img/testimonial/testi_1_5.png" alt="Image" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="swiper th-slider" id="testiSlide7" data-slider-options='{"effect":"slide","loop":true,"thumbs":{"swiper":".testi-grid2-thumb"},"breakpoints":{"0":{"autoHeight":true},"576":{"autoHeight":false}}}'>
              <div className="swiper-wrapper">
                <div className="swiper-slide">
                  <div className="testi-card2">
                    <p className="testi-card2_text">
                      Over the past year, collaborating with Webteck has been a
                      pleasure, and I can attest to their crucial role in driving
                      the success of our IT endeavors. As a startup, finding a tech
                      partner capable of both addressing our current requirements
                      and scaling alongside our growth was paramount. Webteck not
                      only met but surpassed all of our expectations,
                    </p>
                    <div className="testi-card2_profile">
                      <div className="testi-card2_content">
                        <h3 className="box-title">Michel Jane Alum</h3>
                        <span className="testi-card2_desig">CTO of Portfolio</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="testi-card2">
                    <p className="testi-card2_text">
                      If you have specific questions about gathering or analyzing
                      customer feedback, or if you're looking for general
                      information on the importance of customer feedback, feel free
                      to ask. Additionally, if you have a sample of customer
                      feedback that you'd like assistance with, you can share it,
                      and I can provide insights or suggestions based on you provide
                    </p>
                    <div className="testi-card2_profile">
                      <div className="testi-card2_content">
                        <h3 className="box-title">Alex Michel</h3>
                        <span className="testi-card2_desig">Founder CEO</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="testi-card2">
                    <p className="testi-card2_text">
                      It sounds like you're expressing positive feedback or a
                      statement about a product or service being loved by customers
                      worldwide. If this is a statement you want to share or
                      discuss, it's great to highlight positive feedback! Customer
                      satisfaction and positive testimonials can be powerful assets
                      for a product or services businesses I'm here to help!
                    </p>
                    <div className="testi-card2_profile">
                      <div className="testi-card2_content">
                        <h3 className="box-title">Jenny Wilson</h3>
                        <span className="testi-card2_desig">Project Manager</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="testi-card2">
                    <p className="testi-card2_text">
                      If you have a specific question or if there's more information
                      you'd like to provide or discuss regarding your product or
                      service being loved by customers worldwide, feel free to share
                      more details. Whether you're looking for advice on how to
                      leverage this positive feedback, strategies to maintain
                      customer satisfaction, or any other related
                    </p>
                    <div className="testi-card2_profile">
                      <div className="testi-card2_content">
                        <h3 className="box-title">Savannah Nguyen</h3>
                        <span className="testi-card2_desig">UI/UX Designer</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="testi-card2">
                    <p className="testi-card2_text">
                      It's fantastic to hear that your product or service is loved
                      by customers worldwide! Positive customer feedback is a strong
                      indicator of satisfaction and can contribute significantly to
                      the success and reputation of a business. If you're looking to
                      capitalize on this positive sentiment, here are a few as we
                      expand our business topic, Positive customer feedback I'm here
                    </p>
                    <div className="testi-card2_profile">
                      <div className="testi-card2_content">
                        <h3 className="box-title">Cameron Williamson</h3>
                        <span className="testi-card2_desig">Disaster Recovery</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button
                data-slider-prev="#testiSlide7"
                className="slider-arrow slider-prev"
              >
                <i className="far fa-arrow-left" />
              </button>{" "}
              <button
                data-slider-next="#testiSlide7"
                className="slider-arrow slider-next"
              >
                <i className="far fa-arrow-right" />
              </button>
            </div>
            <div className="testi-line" />
          </div>
        </div>
      </section>
      <section className="overflow-hidden space" id="blog-sec">
        <div className="container th-container4">
          <div className="title-area text-center">
            <span className="sub-title text-capitalize fs-20">
              <div className="icon-masking me-2">
                <img src="assets/img/theme-img/title_shape_4.svg" alt="shape" />
              </div>
              News &amp; Blog
            </span>
            <h2 className="sec-title">Our Blog &amp; News</h2>
          </div>
          <div className="slider-area">
          <Slider dots={true} spaceBetween={20} arrows={true} infinite={true} autoplay={true} autoplaySpeed={2500} speed={2500} slidesToShow={3} slidesToScroll={1} responsive={[{ breakpoint: 1200, settings: { slidesToShow: 2 } }, { breakpoint: 768, settings: { slidesToShow: 1 } }, { breakpoint: 480, settings: { slidesToShow: 1 } }]}>
                <div className="swiper-slide">
                  <div className="blog-box2 style2 m-2">
                    <div className="blog-img">
                      <img src="assets/img/blog/blog_6_1.jpg" alt="blog image" />
                    </div>
                    <div className="blog-box2_content">
                      <div className="blog-meta">
                        <a href="blog.html">
                          <i className="far fa-calendar" />
                          10, 2024
                        </a>{" "}
                        <a href="blog.html">
                          <i className="far fa-user" />
                          By admin
                        </a>
                      </div>
                      <h3 className="box-title">
                        <a href="blog-details.html">
                          Webteck Recognized as a Leader in Marketing Automation
                        </a>
                      </h3>
                      <a href="blog-details.html" className="line-btn">
                        Read Details
                        <i className="fa-solid fa-angles-right" />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="blog-box2 style2 m-2">
                    <div className="blog-img">
                      <img src="assets/img/blog/blog_6_2.jpg" alt="blog image" />
                    </div>
                    <div className="blog-box2_content">
                      <div className="blog-meta">
                        <a href="blog.html">
                          <i className="far fa-calendar" />
                          15, 2024
                        </a>{" "}
                        <a href="blog.html">
                          <i className="far fa-user" />
                          By admin
                        </a>
                      </div>
                      <h3 className="box-title">
                        <a href="blog-details.html">
                          Our Customers Are Crushing It! Read Their Success Stories
                        </a>
                      </h3>
                      <a href="blog-details.html" className="line-btn">
                        Read Details
                        <i className="fa-solid fa-angles-right" />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="blog-box2 style2 m-2">
                    <div className="blog-img">
                      <img src="assets/img/blog/blog_6_3.jpg" alt="blog image" />
                    </div>
                    <div className="blog-box2_content">
                      <div className="blog-meta">
                        <a href="blog.html">
                          <i className="far fa-calendar" />
                          16, 2024
                        </a>{" "}
                        <a href="blog.html">
                          <i className="far fa-user" />
                          By admin
                        </a>
                      </div>
                      <h3 className="box-title">
                        <a href="blog-details.html">
                          Stay Ahead of the Curve: Webteck's Take on the Latest
                        </a>
                      </h3>
                      <a href="blog-details.html" className="line-btn">
                        Read Details
                        <i className="fa-solid fa-angles-right" />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="blog-box2 style2 m-2">
                    <div className="blog-img">
                      <img src="assets/img/blog/blog_6_1.jpg" alt="blog image" />
                    </div>
                    <div className="blog-box2_content">
                      <div className="blog-meta">
                        <a href="blog.html">
                          <i className="far fa-calendar" />
                          17, 2024
                        </a>{" "}
                        <a href="blog.html">
                          <i className="far fa-user" />
                          By admin
                        </a>
                      </div>
                      <h3 className="box-title">
                        <a href="blog-details.html">
                          Webteck Recognized as a Leader in Marketing Automation
                        </a>
                      </h3>
                      <a href="blog-details.html" className="line-btn">
                        Read Details
                        <i className="fa-solid fa-angles-right" />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="blog-box2 style2 m-2">
                    <div className="blog-img">
                      <img src="assets/img/blog/blog_6_2.jpg" alt="blog image" />
                    </div>
                    <div className="blog-box2_content">
                      <div className="blog-meta">
                        <a href="blog.html">
                          <i className="far fa-calendar" />
                          19, 2024
                        </a>{" "}
                        <a href="blog.html">
                          <i className="far fa-user" />
                          By admin
                        </a>
                      </div>
                      <h3 className="box-title">
                        <a href="blog-details.html">
                          Our Customers Are Crushing It! Read Their Success Stories
                        </a>
                      </h3>
                      <a href="blog-details.html" className="line-btn">
                        Read Details
                        <i className="fa-solid fa-angles-right" />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="blog-box2 style2 m-2">
                    <div className="blog-img">
                      <img src="assets/img/blog/blog_6_3.jpg" alt="blog image" />
                    </div>
                    <div className="blog-box2_content">
                      <div className="blog-meta">
                        <a href="blog.html">
                          <i className="far fa-calendar" />
                          20, 2024
                        </a>{" "}
                        <a href="blog.html">
                          <i className="far fa-user" />
                          By admin
                        </a>
                      </div>
                      <h3 className="box-title">
                        <a href="blog-details.html">
                          Stay Ahead of the Curve: Webteck's Take on the Latest
                        </a>
                      </h3>
                      <a href="blog-details.html" className="line-btn">
                        Read Details
                        <i className="fa-solid fa-angles-right" />
                      </a>
                    </div>
                  </div>
                </div>
              </Slider>
          </div>
        </div>
      </section>
      <Footer />

    </>

  );
}

export default Index;
